document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.card-items.card-row-division');
  if (!container) return;

  const items = container.querySelectorAll('.card-item');
  const rowCountClass = [...container.classList].find(cls => cls.startsWith('card-items-count-'));
  const rowCount = parseInt(rowCountClass.split('-').pop());

  const totalItems = items.length;

  // Function to get items per row based on media query
  function getItemsPerRow() {
    let itemsPerRow = rowCount; // Default items per row

    if (window.matchMedia('(min-width: 992px)').matches) {
      itemsPerRow = rowCount; // lg (992px and above) - card-items-count-x
    } else if (window.matchMedia('(min-width: 768px)').matches) {
      itemsPerRow = rowCount > 5 ? 3 : Math.ceil(rowCount / 2); // md (768px and above) - dynamic for card-items-count-5
    } else if (window.matchMedia('(min-width: 576px)').matches) {
      itemsPerRow = 2; // sm (576px and above)
    } else {
      itemsPerRow = 1; // xs (below 576px)
    }

    return itemsPerRow;
  }

  // Apply borders based on the number of items per row
  function applyBorders() {
    const itemsPerRow = getItemsPerRow();
    const fullRows = Math.floor(totalItems / itemsPerRow); // Count of full rows
    const itemsToBorder = fullRows * itemsPerRow; // Only apply border to items in full rows

    items.forEach((item, index) => {
      if (index < itemsToBorder) {
        item.style.borderBottom = '1px solid black';
      } else {
        item.style.borderBottom = 'none'; // Ensure no border for excess items
      }
    });

    // Special case: if itemsPerRow is 1, apply border to all but the last item
    if (itemsPerRow === 1) {
      items.forEach((item, index) => {
        if (index < totalItems - 1) {
          item.style.borderBottom = '1px solid black';
        } else {
          item.style.borderBottom = 'none';
        }
      });
    }
  }

  // Initial application of borders
  applyBorders();

  // Reapply borders on window resize to account for breakpoint changes
  window.addEventListener('resize', applyBorders);
});
